import type { Contract } from '@/types/api/contract';

// Courtiers « self-service » : leurs clients peuvent mettre à jour leur numéro
// de téléphone eux-mêmes depuis l'espace assuré (même parcours que le direct).
// Pour tous les autres courtiers, la mise à jour passe obligatoirement par le
// courtier : on affiche la popin bloquante MFA « contactez votre courtier ».
// L'identification se fait sur l'id apporteur1 du contrat
// (contracts.data[n].apporteur1), comme pour le direct (43397).
const SELF_SERVICE_BROKER_IDS = [
  '111619', // LSA Courtage
  '479835', // RVA
  '479846', // AssurPeople
  '809466', // Les Furets Assurances
];

export const hasSelfServiceBrokerContract = (contracts: Contract[] | null | undefined): boolean =>
  Array.isArray(contracts) &&
  contracts.some(c => SELF_SERVICE_BROKER_IDS.includes(String(c?.apporteur1)));
